import { render, staticRenderFns } from "./HeaderWrapper.vue?vue&type=template&id=2dda99d9&scoped=true"
import script from "./HeaderWrapper.vue?vue&type=script&lang=js"
export * from "./HeaderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda99d9",
  null
  
)

export default component.exports